import {EventBroker} from "@frontend/lib/utils/event-broker";

export const EVENTS = {
    SAVED: 'SAVED',
    INIT: 'INIT',
    CLOSED: 'CLOSED',
    BULK_COPY: 'BULK_COPY',
    BULK_COPY_SELECTED: 'BULK_COPY_SELECTED',
    PROGRESS: 'PROGRESS',
}

export const copyAndResizeEventBroker = new EventBroker();
